import React from 'react';
import { motion } from 'framer-motion';
export function ConfidentialBanner() {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="sticky top-0 z-50 w-full bg-[#0a0f1a] border-b border-[#c9a84c]/30 py-2.5 md:py-3 px-3 md:px-4 text-center shadow-lg" data-id="element-21">
      <p className="text-[#c9a84c] text-[10px] md:text-sm font-bold tracking-[0.1em] md:tracking-[0.2em] uppercase" data-id="element-22">
        Confidential Strategy for Conservative Investors Over 50
      </p>
    </motion.div>;
}